import * as LessonConnector from 'Modules/LessonModule';
import { Lesson } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Lesson.END_LESSON_INIT,
});

export const success = (data) => ({
  type: Lesson.END_LESSON_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Lesson.END_LESSON_FAILURE,
});

const endLesson = (uuid) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await LessonConnector.Connector.endLesson(uuid);
    dispatch(success(response.data.lessonSerialize));
    return response.data.lessonSerialize;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default endLesson;
